import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { RegistrationService } from '../../services/registration.service';
import { DataService } from '../../services/data.service';

/** Logged-out cold start / logout: guest when a device org exists, else postcode. */
export function entryUrl(registrationService: RegistrationService): string {
  return registrationService.hasDeviceOrganisation() ? '/guest' : '/postcode-entry';
}

/**
 * Keeps guest, postcode-entry, and login aligned for logged-out users.
 * Login stays reachable when the user chose it from guest (org already stored).
 */
export const appEntryGuard: CanActivateFn = async (_route, state) => {
  const registrationService = inject(RegistrationService);
  const data = inject(DataService);
  const router = inject(Router);

  // Logout clears isUserLogged; in-memory token can lag — trust the flag only.
  if (data.isUserLogged) {
    return true;
  }

  await registrationService.ensureDeviceOrganisation();

  const path = state.url.split('?')[0];
  const fromGuestBack = router.getCurrentNavigation()?.extras?.state?.['fromGuestBack'] === true;
  if (fromGuestBack && path.startsWith('/postcode-entry')) {
    return true;
  }

  const loggedOutEntry = entryUrl(registrationService);

  if (path === '/login' || path === '/login/nhs') {
    if (loggedOutEntry === '/postcode-entry') {
      return router.parseUrl('/postcode-entry');
    }
    return true;
  }

  if (path === '/guest' && loggedOutEntry === '/postcode-entry') {
    return router.parseUrl('/postcode-entry');
  }

  if (path.startsWith('/postcode-entry') && loggedOutEntry === '/guest') {
    return router.parseUrl('/guest');
  }

  return true;
};
